import { gql } from 'urql';

import { CART_FRAGMENT } from 'gql/fragments/cart';

export const ADD_ITEMS_TO_CART_MUTATION = gql`
  mutation AddItemsToCart($input: AddItemsToCartInput!) {
    addItemsToCart(input: $input) {
      ...cartFields
    }
  }

  ${CART_FRAGMENT}
`;

export const UPDATE_CART_ITEM_MUTATION = gql`
  mutation UpdateItemInCart($input: UpdateItemInCartInput!) {
    updateItemInCart(input: $input) {
      ...cartFields
    }
  }

  ${CART_FRAGMENT}
`;

export const REMOVE_ITEM_FROM_CART_MUTATION = gql`
  mutation RemoveItemFromCart($input: RemoveItemFromCartInput!) {
    removeItemFromCart(input: $input) {
      ...cartFields
    }
  }

  ${CART_FRAGMENT}
`;

export const ADD_GIFTCARD_TO_CART_MUTATION = gql`
  mutation AddGiftCardToCart($input: AddGiftCardToCartInput!) {
    addGiftCardToCart(input: $input) {
      ...cartFields
    }
  }

  ${CART_FRAGMENT}
`;

export const REMOVE_GIFT_CARD_FROM_CART_MUTATION = gql`
  mutation RemoveGiftCardFromCart($input: RemoveGiftCardFromCartInput!) {
    removeGiftCardFromCart(input: $input) {
      ...cartFields
    }
  }

  ${CART_FRAGMENT}
`;

export const ADD_GIFT_CARD_MUTATION = gql`
  mutation AddGiftCard($input: AddGiftCardInput!) {
    addGiftCard(input: $input) {
      ...cartFields
    }
  }

  ${CART_FRAGMENT}
`;

export const REMOVE_GIFT_CARD_MUTATION = gql`
  mutation RemoveGiftCard($input: RemoveGiftCardInput!) {
    removeGiftCard(input: $input) {
      ...cartFields
    }
  }

  ${CART_FRAGMENT}
`;

export const UPDATE_SHIPPING_ADDRESS_MUTATION = gql`
  mutation UpdateShippingAddress($input: UpdateShippingAddressInput!) {
    updateShippingAddress(input: $input) {
      ...cartFields
    }
  }

  ${CART_FRAGMENT}
`;

export const UPDATE_SHIPMENT_METHOD = gql`
  mutation UpdateShipmentMethod($input: UpdateShipmentMethodInput!) {
    updateShipmentMethod(input: $input) {
      ...cartFields
    }
  }

  ${CART_FRAGMENT}
`;

export const UPDATE_BILLING_ADDRESS_MUTATION = gql`
  mutation UpdateBillingAddress($input: UpdateBillingAddressInput!) {
    updateBillingAddress(input: $input) {
      ...cartFields
    }
  }

  ${CART_FRAGMENT}
`;

export const REMOVE_COUPON_FROM_CART_MUTATION = gql`
  mutation RemoveCouponFromCart($input: RemoveCouponFromCartInput!) {
    removeCouponFromCart(input: $input) {
      ...cartFields
    }
  }

  ${CART_FRAGMENT}
`;

export const ADD_COUPON_TO_CART_MUTATION = gql`
  mutation AddCouponToCart($input: AddCouponToCartInput!) {
    addCouponToCart(input: $input) {
      ...cartFields
    }
  }

  ${CART_FRAGMENT}
`;

export const ADD_PAYMENT_PROMOTION_MUTATION = gql`
  mutation AddPaymentPromotion($input: AddPaymentPromotionInput!) {
    addPaymentPromotion(input: $input) {
      ...cartFields
    }
  }

  ${CART_FRAGMENT}
`;

export const ADD_AMBASSADOR_CARD_TO_CART_MUTATION = gql`
  mutation AddAmbassadorCardToCart($input: AddAmbassadorCardToCartInput!) {
    addAmbassadorCardToCart(input: $input) {
      ...cartFields
    }
  }

  ${CART_FRAGMENT}
`;

export const REMOVE_AMBASSADOR_CARD_FROM_CART_MUTATION = gql`
  mutation RemoveAmbassadorCardFromCart(
    $input: RemoveAmbassadorCardFromCartInput!
  ) {
    removeAmbassadorCardFromCart(input: $input) {
      ...cartFields
    }
  }

  ${CART_FRAGMENT}
`;

export const ADD_STORE_CREDITS_MUTATION = gql`
  mutation AddStoreCredits($input: AddStoreCreditsInput!) {
    addStoreCredits(input: $input) {
      cart {
        ...cartFields
      }
    }
  }

  ${CART_FRAGMENT}
`;

export const REMOVE_STORE_CREDITS_MUTATION = gql`
  mutation RemoveStoreCredits($input: RemoveStoreCreditsInput!) {
    removeStoreCredits(input: $input) {
      cart {
        ...cartFields
      }
    }
  }

  ${CART_FRAGMENT}
`;
